import { render } from "./CIS-Tabs.vue?vue&type=template&id=05eed60a&scoped=true"
import script from "./CIS-Tabs.vue?vue&type=script&lang=js"
export * from "./CIS-Tabs.vue?vue&type=script&lang=js"

import "./CIS-Tabs.vue?vue&type=style&index=0&id=05eed60a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05eed60a"]])

export default __exports__